import React from "react";
import { motion } from "framer-motion";

export const TopProgressBar = ({ value = 0 }) => {
  return (
    <div className="fixed top-0 left-0 right-0 h-[3px] bg-[#E5E7EB]/60 z-50" data-testid="top-progress-bar">
      <motion.div
        className="h-full bg-[#1FA8E0]"
        initial={{ width: 0 }}
        animate={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      />
    </div>
  );
};
